import React, { useState, useEffect, useCallback } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Steps } from "primereact/steps";
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from "primereact/toast";
import { useGlobalContext } from "../Config";

/**
 * Componente FormCrearCliente
 * Maneja la creación y edición de clientes con un formulario multi-paso
 * @param {Object} props - Propiedades del componente
 * @param {Array} props.Empresas - Lista de empresas disponibles
 * @param {string} props.baseUrl - URL base para las peticiones API
 * @param {string} props.urlMedidores - URL para el servicio de medidores
 * @param {string} props.urlDocumentos - URL para el servicio de documentos
 * @param {string} props.urlCobranzas - URL para el servicio de cobranzas
 * @param {Function} props.onSuccess - Callback para éxito
 * @param {Function} props.onError - Callback para error
 * @param {Function} props.onClose - Callback para cerrar
 */
const FormCrearCliente = ({
  // CLIENTE
  modoEdicion,
  clienteData,
  onSuccess,
  onError,
  onClose,
  fetchData,
}) => {



  const { baseUrl, urlMedidores, urlDocumentos, urlCobranzas } = useGlobalContext();
  const toast = React.useRef();
  // Estados locales para cliente
  const [nuevaEmpresa, setNuevaEmpresa] = useState("");
  const [nuevoTipo, setNuevoTipo] = useState("");
  const [nuevoRut, setNuevoRut] = useState("");
  const [nuevaRazon, setNuevaRazon] = useState("");
  const [nuevoAlias, setNuevoAlias] = useState("");
  const [nuevoFanta, setNuevoFanta] = useState("");
  const [giro, setGiro] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [rutExiste, setRutExiste] = useState(false);

  // Estados locales para representante
  const [nuevoNombreRepresentante, setNuevoNombreRepresentante] = useState("");
  const [nuevoRutRepresentante, setNuevoRutRepresentante] = useState("");
  const [nuevoTelefonoRepresentante, setNuevoTelefonoRepresentante] = useState("");
  const [nuevoCorreoRepresentante, setNuevoCorreoRepresentante] = useState("");
  const [nuevoRepresentantes, setNuevoRepresentantes] = useState([]);
  const [isValidRepresentante, setIsValidRepresentante] = useState(false);
  const [codigoPais, setCodigoPais] = useState("+56");
  const [codigoPaisContacto, setCodigoPaisContacto] = useState("+56");
  const [erroresRepresentante, setErroresRepresentante] = useState({
    nombre: false,
    rut: false,
    telefono: false,
    correo: false
  });

  const codigosPaises = [
    { label: 'Chile (+56)', value: '+56' },
    { label: 'Argentina (+54)', value: '+54' },
    { label: 'Perú (+51)', value: '+51' }
  ];

  // Estados locales para dirección
  const [nuevaDireccion, setNuevaDireccion] = useState("");
  const [nuevoTipoDireccion, setNuevoTipoDireccion] = useState("");
  const [comuna, setComuna] = useState("");
  const [region, setRegion] = useState("");
  const [regiones, setRegiones] = useState([]);
  const [comunas, setComunas] = useState([]);
  const [nuevoDirecciones, setNuevoDirecciones] = useState([]);

  // Estados locales para contacto
  const [nuevoContactos, setNuevoContactos] = useState([]);
  const [nuevoNombreContacto, setNuevoNombreContacto] = useState("");
  const [nuevoTipoContacto, setNuevoTipoContacto] = useState("");
  const [nuevoTelefonoContacto, setNuevoTelefonoContacto] = useState("");
  const [nuevoCorreoContacto, setNuevoCorreoContacto] = useState("");

  // Otros estados
  const [idCliente, setIdCliente] = useState("");
  const [loading, setLoading] = useState(false);
  const [indiceEdicionRepresentante, setIndiceEdicionRepresentante] = useState(null);
  const [indiceEdicionDireccion, setIndiceEdicionDireccion] = useState(null);
  const [indiceEdicionContacto, setIndiceEdicionContacto] = useState(null);
  const [idRepresentante, setIdRepresentante] = useState(null);
  const [idDomicilio, setIdDomicilio] = useState(null);
  const [idContacto, setIdContacto] = useState(null);
  const [empresas, setEmpresas] = useState([]);
  const [tipos, setTipos] = useState([]);

  const [camposTocados, setCamposTocados] = useState({
    empresa: false,
    rut: false,
    razonSocial: false,
    giro: false,
    alias: false,
    tipoCliente: false,
    nombreFantasia: false
  });

  const handleCampoTocado = (campo) => {
    setCamposTocados(prev => ({
      ...prev,
      [campo]: true
    }));
  };

  const mostrarError = (campo) => {
    if (campo === 'rut') {
      return (camposTocados[campo] && !camposValidos[campo]) || rutExiste;
    }
    return camposTocados[campo] && !camposValidos[campo];
  };

  /**
   * Funciones de reset de formularios
   */
  const resetFormularioRepresentante = useCallback(() => {
    setNuevoNombreRepresentante("");
    setNuevoRutRepresentante("");
    setNuevoTelefonoRepresentante("");
    setNuevoCorreoRepresentante("");
    setIndiceEdicionRepresentante(null);
  }, [
    setNuevoNombreRepresentante,
    setNuevoRutRepresentante,
    setNuevoTelefonoRepresentante,
    setNuevoCorreoRepresentante,
  ]);

  const resetFormularioDireccion = useCallback(() => {
    setNuevaDireccion("");
    setNuevoTipoDireccion("");
    setRegion("");
    setComuna("");
    setIndiceEdicionDireccion(null);
  }, [
    setNuevaDireccion,
    setNuevoTipoDireccion,
    setComuna,
    setRegion,
  ]);

  const resetFormularioContacto = useCallback(() => {
    setNuevoNombreContacto("");
    setNuevoTipoContacto("");
    setNuevoTelefonoContacto("");
    setNuevoCorreoContacto("");
    setIndiceEdicionContacto(null);
  }, [
    setNuevoNombreContacto,
    setNuevoTelefonoContacto,
    setNuevoCorreoContacto,
    setNuevoTipoContacto,
  ]);

  /**
   * Efectos y estados para el modo de edición
   */
  useEffect(() => {
    if (clienteData) {
      // Resetear formularios
      resetFormularioRepresentante();
      resetFormularioDireccion();
      resetFormularioContacto();

      // Establecer datos del cliente
      setNuevaEmpresa(clienteData.id_empresa || "");
      setNuevoTipo(clienteData.id_tipo_cliente || "");
      setNuevoRut(clienteData.rut || "");
      setIsValid(validateRut(cleanRut(clienteData.rut || "")));
      setNuevaRazon(clienteData.razon_social || "");
      setNuevoAlias(clienteData.alias || "");
      setNuevoFanta(clienteData.nombre_fantasia || "");
      setGiro(clienteData.giro || "");
      setIdCliente(clienteData.id || "");

      // Establecer representantes (backend property may be "representantes" or "representantes_legales")
      if (Array.isArray(clienteData.representantes_legales) && clienteData.representantes_legales.length > 0) {
        setNuevoRepresentantes(clienteData.representantes_legales);
      } else if (Array.isArray(clienteData.representantes) && clienteData.representantes.length > 0) {
        setNuevoRepresentantes(clienteData.representantes);
      }

      // Establecer direcciones
      if (clienteData.domicilios) {
        setNuevoDirecciones(clienteData.domicilios);
      }

      // Establecer contactos
      if (clienteData.contactos) {
        setNuevoContactos(clienteData.contactos);
      }
    }
  }, [clienteData]);

  // Efecto para cargar datos iniciales
  useEffect(() => {
    obtenerEmpresas();
    obtenerTipoCliente();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  /**
   * Estados y funciones para el manejo de pasos del formulario
   */
  const [activeStep, setActiveStep] = useState(0);
  const [camposValidos, setCamposValidos] = useState({
    empresa: false,
    rut: false,
    razonSocial: false,
    giro: false,
    alias: false,
    tipoCliente: false,
    nombreFantasia: false
  });
  const [formularioValido, setFormularioValido] = useState(false);

  const stepsItems = [
    { label: "Cliente", command: () => setActiveStep(0) },
    { label: "Representante Legal", command: () => setActiveStep(1) },
    { label: "Dirección", command: () => setActiveStep(2) },
    { label: "Contacto", command: () => setActiveStep(3) },
  ];

  const validarCampos = useCallback(() => {
    const nuevosCamposValidos = {
      empresa: !!nuevaEmpresa,
      rut: isValid && !!nuevoRut,
      razonSocial: !!nuevaRazon,
      giro: !!giro,
      alias: !!nuevoAlias,
      tipoCliente: !!nuevoTipo,
      nombreFantasia: !!nuevoFanta
    };
    setCamposValidos(nuevosCamposValidos);
    setFormularioValido(Object.values(nuevosCamposValidos).every(valor => valor));
  }, [
    nuevaEmpresa,
    isValid,
    nuevoRut,
    nuevaRazon,
    giro,
    nuevoAlias,
    nuevoTipo,
    nuevoFanta
  ]);

  useEffect(() => {
    validarCampos();
  }, [validarCampos]);

  const handleStepChange = (e) => {
    setActiveStep(e.index);
  };

  /**
   * Funciones para obtener datos del servidor
   */
  const obtenerEmpresas = async () => {
    try {
      const urlEmpresas = `${baseUrl}getAllEmpresas`;
      const data = await fetchData(urlEmpresas);
      if (Array.isArray(data.empresas)) {
        setEmpresas(data.empresas);
      } else {
        throw new Error("Formato de respuesta inesperado");
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const obtenerTipoCliente = async () => {
    try {
      const urlTipos = `${baseUrl}getAllTipoClientes`;
      const data = await fetchData(urlTipos);
      if (Array.isArray(data.tipos)) {
        setTipos(data.tipos);
      } else {
        throw new Error("Formato de respuesta inesperado");
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  // Efecto para inicializar los estados cuando se cargan los datos
  useEffect(() => {
    if (empresas.length > 0 && nuevaEmpresa) {
      //console.log("Estado actual de nuevaEmpresa:", nuevaEmpresa);
    }
    if (tipos.length > 0 && nuevoTipo) {
      //console.log("Estado actual de nuevoTipo:", nuevoTipo);
    }
  }, [empresas, tipos, nuevaEmpresa, nuevoTipo]);

  // Efecto para cargar las regiones al montar el componente
  useEffect(() => {
    const publicUrl = process.env.PUBLIC_URL || '';
    fetch(`${publicUrl}/comunas-regiones.json`)
      .then(response => response.json())
      .then(data => {
        const regionesFormateadas = data.regiones.map(r => ({
          label: r.region,
          value: r.region
        }));
        setRegiones(regionesFormateadas);
      })
      .catch(error => {
        console.error('Error al cargar las regiones:', error);
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudieron cargar las regiones',
          life: 3000
        });
      });
  }, []);

  // Efecto para actualizar las comunas cuando cambia la región
  useEffect(() => {
    if (region) {
      const publicUrl = process.env.PUBLIC_URL || '';
      fetch(`${publicUrl}/comunas-regiones.json`)
        .then(response => response.json())
        .then(data => {
          const regionSeleccionada = data.regiones.find(r => r.region === region);
          if (regionSeleccionada) {
            const comunasFormateadas = regionSeleccionada.comunas.map(comuna => ({
              label: comuna,
              value: comuna
            }));
            setComunas(comunasFormateadas);
          }
        })
        .catch(error => {
          console.error('Error al cargar las comunas:', error);
        });
    } else {
      setComunas([]);
    }
  }, [region]);

  // --------- VALIDACIONES ---------
  /**
   * Utilidades de validación y formato de RUT
   */
  const cleanRut = (rut) => rut.replace(/^0+|[^0-9kK]+/g, "").toUpperCase();

  const validateRut = (rut) => {
    if (!rut || typeof rut !== "string") return false;
    const cleanRutVal = cleanRut(rut);
    if (cleanRutVal.length < 2) return false;

    const body = cleanRutVal.slice(0, -1);
    const verifier = cleanRutVal.slice(-1);

    let sum = 0;
    let multiplier = 2;

    for (let i = body.length - 1; i >= 0; i--) {
      sum += multiplier * +body[i];
      multiplier = multiplier === 7 ? 2 : multiplier + 1;
    }

    const mod = 11 - (sum % 11);
    const expectedVerifier = mod === 11 ? "0" : mod === 10 ? "K" : mod.toString();

    return expectedVerifier === verifier;
  };

  const formatRut = (rut) => {
    const cleanRutVal = cleanRut(rut);
    let result = cleanRutVal.slice(-4, -1) + "-" + cleanRutVal.substr(cleanRutVal.length - 1);

    for (let i = 4; i < cleanRutVal.length; i += 3) {
      result = cleanRutVal.slice(-3 - i, -i) + "." + result;
    }

    return result;
  };

  /**
   * Manejadores de eventos para campos de formulario
   */
  const handleRutChange = (event) => {
    const inputRut = event.target.value;
    setNuevoRut(inputRut);
    const cleanRutVal = cleanRut(inputRut);
    setIsValid(validateRut(cleanRutVal));
    setRutExiste(false);
  };

  const handleRutBlur = async () => {
    if (isValid) {
      setNuevoRut(formatRut(nuevoRut));
      const rutLimpio = nuevoRut.replace(/[.\s]/g, "");
      try {
        const urlrut = `${baseUrl}getClienteByRut?rut=${rutLimpio}`;
        const data = await fetchData(urlrut);
        if (data === true) {
          setRutExiste(true);
            toast.current.show({
              severity: "error",
              summary: "Rechazado",
              detail: "El RUT del cliente ya existe",
              life: 3000,
            });
        } else {
          setRutExiste(false);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error al verificar RUT:", error);
        setLoading(false);
      }
    }
  };

  const handleRutRepresentanteChange = (event) => {
    const inputRut = event.target.value;
    setNuevoRutRepresentante(inputRut);
    setIsValidRepresentante(validateRut(cleanRut(inputRut)));
  };

  const handleRutRepresentanteBlur = async () => {
    if (isValidRepresentante) {
      // Formatear el RUT solo si no tiene guion
      let rutLimpio = nuevoRutRepresentante.replace(/[.\s]/g, ""); // solo elimina puntos y espacios
      let rutFormateado = nuevoRutRepresentante;
      if (!/-/.test(nuevoRutRepresentante)) {
        rutFormateado = rutLimpio.slice(0, -1) + "-" + rutLimpio.slice(-1);
      }
      setNuevoRutRepresentante(rutFormateado);
      // Buscar el representante por RUT (con guion)
      try {
        const rutParaBuscar = rutFormateado;
        const urlrutf = `${baseUrl}getRepresentanteByRut?rut=${rutParaBuscar}`;
        const data = await fetchData(urlrutf);
        if (data) {
          // Rellenar los campos con los datos recibidos
          setNuevoNombreRepresentante(data.nombre || "");
          setNuevoCorreoRepresentante(data.correo || "");
          // Extraer el número de teléfono sin el código de país
          const telefono = data.telefono ? data.telefono.replace(/^[+\d\s()-]+/, '') : "";
          setNuevoTelefonoRepresentante(telefono);
          // Si el teléfono comienza con +56, establecer el código de país
          if (data.telefono && data.telefono.startsWith("+56")) {
            setCodigoPais("+56");
          }
        }
        
      } catch (error) {
        console.error("Error al buscar representante:", error);
      }
    }
  };

  /**
   * Validadores de campos
   */
  const validateTelefono = (tel) => {
    const cleanTel = tel.replace(/[^0-9]/g, '');
    return /^[0-9\s()+-]+$/.test(tel) && cleanTel.length >= 8;
  };
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  /**
   * Manejadores de eventos para campos de contacto
   */
  const handleTelefonoRepresentanteChange = (e) => {
    setNuevoTelefonoRepresentante(e.target.value.replace(/[^0-9\s()+-]/g, ""));
  };

  const handleCorreoRepresentanteChange = (e) => {
    setNuevoCorreoRepresentante(e.target.value);
  };

  const handleTelefonoContactoChange = (e) => {
    setNuevoTelefonoContacto(e.target.value.replace(/[^0-9\s()+-]/g, ""));
  };

  const handleCorreoContactoChange = (e) => {
    setNuevoCorreoContacto(e.target.value);
  };
  
  // --------- FUNCIONES REPRESENTANTES ---------
  const handleGuardarRepresentante = () => {
    // Validar campos
    const nuevosErrores = {
      nombre: !nuevoNombreRepresentante.trim(),
      //rut: !isValidRepresentante,
      telefono: !nuevoTelefonoRepresentante.trim() || !validateTelefono(nuevoTelefonoRepresentante),
      correo: !nuevoCorreoRepresentante.trim() || !validateEmail(nuevoCorreoRepresentante)

    };

    setErroresRepresentante(nuevosErrores);

    // Si hay errores, no continuar pero mantener los datos
    if (Object.values(nuevosErrores).some(error => error)) {
      toast.current.show({
        severity: "error",
        summary: "Error de Validación",
        detail: "Por favor, complete correctamente todos los campos",
        life: 3000,
      });
      return;
    }

    if (indiceEdicionRepresentante !== null) {
      const actualizados = [...nuevoRepresentantes];
      actualizados[indiceEdicionRepresentante] = {
        id: idRepresentante,
        nombre: nuevoNombreRepresentante,
        rut: nuevoRutRepresentante,
        telefono: `${codigoPais} ${nuevoTelefonoRepresentante}`,
        correo: nuevoCorreoRepresentante,
      };
      setNuevoRepresentantes(actualizados);
      setIndiceEdicionRepresentante(null);
      resetFormularioRepresentante();
    } else {
      handleAgregarNuevoRepresentante();
    }
  };

  const handleAgregarNuevoRepresentante = () => {
    if (nuevoRepresentantes.some((rep) => rep.rut.trim().toUpperCase() === nuevoRutRepresentante.trim().toUpperCase())) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "El representante con este RUT ya existe",
        life: 3000,
      });
      return;
    }

    const representante = {
      rut: nuevoRutRepresentante,
      nombre: nuevoNombreRepresentante,
      correo: nuevoCorreoRepresentante,
      telefono: `${codigoPais} ${nuevoTelefonoRepresentante}`,
    };

    const updatedRepresentantes = [...nuevoRepresentantes, representante];
    setNuevoRepresentantes(updatedRepresentantes);

    resetFormularioRepresentante();
  };

  const handleEliminarRepresentante = (rowIndex) => {
    const updatedRepresentantes = [...nuevoRepresentantes];
    updatedRepresentantes.splice(rowIndex, 1);
    setNuevoRepresentantes(updatedRepresentantes);
  };

  const handleSeleccionarRepresentante = (index) => {
    const rep = nuevoRepresentantes[index];
    //pasando id
    setIdRepresentante(rep.id);
    setNuevoNombreRepresentante(rep.nombre);
    setNuevoRutRepresentante(rep.rut);
    setNuevoTelefonoRepresentante(rep.telefono.replace(/^\+\d+\s*/, ''));
    setNuevoCorreoRepresentante(rep.correo);
    setIndiceEdicionRepresentante(index);
  };
  
  /**
   * Funciones de gestión de direcciones
   */
  const handleAgregarNuevoDireccion = () => {
    const missingFields = checkFormDireccion();
    if (missingFields.length > 0) {
      toast.current.show({
        severity: "error",
        summary: "Error de Validación",
        detail: "Por favor, complete correctamente los siguientes campos: " + missingFields.join(", "),
        life: 3000,
      });
      return;
    }

    if (nuevoDirecciones.some((dir) => 
      dir.direccion.trim().toUpperCase() === nuevaDireccion.trim().toUpperCase() &&
      dir.tipo.trim().toUpperCase() === nuevoTipoDireccion.trim().toUpperCase() &&
      dir.comuna.trim().toUpperCase() === comuna.trim().toUpperCase()
    )) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Esta dirección ya existe",
        life: 3000,
      });
      return;
    }

    const direccion = {
      direccion: nuevaDireccion,
      tipo: nuevoTipoDireccion,
      comuna: comuna,
      region: region,
    };

    setNuevoDirecciones([...nuevoDirecciones, direccion]);
    resetFormularioDireccion();
  };

  const handleEliminarDireccion = (rowIndex) => {
    setNuevoDirecciones(nuevoDirecciones.filter((_, index) => index !== rowIndex));
  };

  const checkFormDireccion = () => {
    const missingFields = [];
    if (!nuevoTipoDireccion) missingFields.push("Tipo Direccion");
    if (!nuevaDireccion) missingFields.push("Direccion");
    if (!region) missingFields.push("Region");
    if (!comuna) missingFields.push("comuna");
    return missingFields;
  };

  const handleSeleccionarDireccion = (index) => {
    const dir = nuevoDirecciones[index];
    setIdDomicilio(dir.id);
    setNuevaDireccion(dir.direccion);
    setNuevoTipoDireccion(dir.tipo);
    setRegion(dir.region);
    setComuna(dir.comuna);
    setIndiceEdicionDireccion(index);
  };

  const handleGuardarDireccion = () => {
    const missingFields = checkFormDireccion();
    if (missingFields.length > 0) {
      toast.current.show({
        severity: "error",
        summary: "Error de Validación",
        detail: "Por favor, complete correctamente los siguientes campos: " + missingFields.join(", "),
        life: 3000,
      });
      return;
    }

    if (nuevoDirecciones.some((dir) => 
      dir.direccion.trim().toUpperCase() === nuevaDireccion.trim().toUpperCase() &&
      dir.tipo.trim().toUpperCase() === nuevoTipoDireccion.trim().toUpperCase() &&
      dir.comuna.trim().toUpperCase() === comuna.trim().toUpperCase()
    )) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Esta dirección ya existe",
        life: 3000,
      });
      return;
    }

    if (indiceEdicionDireccion !== null) {
      const actualizados = [...nuevoDirecciones];
      actualizados[indiceEdicionDireccion] = {
        id: idDomicilio,
        direccion: nuevaDireccion,
        tipo: nuevoTipoDireccion,
        comuna: comuna,
        region: region,
      };
      setNuevoDirecciones(actualizados);
      setIndiceEdicionDireccion(null);
      resetFormularioDireccion();
    } else {
      handleAgregarNuevoDireccion();
    }
  };

  /**
   * Funciones de gestión de contactos
   */
  const handleGuardarContacto = () => {
    const missingFields = checkFormContacto();
    if (missingFields.length > 0) {
      toast.current.show({
        severity: "error",
        summary: "Error de Validación",
        detail: "Por favor, complete correctamente los siguientes campos: " + missingFields.join(", "),
        life: 3000,
      });
      return;
    }

    if (nuevoContactos.some((contact) => 
      contact.correo.trim().toUpperCase() === nuevoCorreoContacto.trim().toUpperCase()
    )) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Un contacto con este correo ya existe",
        life: 3000,
      });
      return;
    }

    if (indiceEdicionContacto !== null) {
      const actualizados = [...nuevoContactos];
      actualizados[indiceEdicionContacto] = {
        id: idContacto,
        nombre: nuevoNombreContacto,
        tipo: nuevoTipoContacto,
        telefono: `${codigoPaisContacto} ${nuevoTelefonoContacto}`,
        correo: nuevoCorreoContacto,
      };
      setNuevoContactos(actualizados);
      setIndiceEdicionContacto(null);
      resetFormularioContacto();
    } else {
      const contacto = {
        nombre: nuevoNombreContacto || "SIN NOMBRE",
        tipo: nuevoTipoContacto || "SIN TIPO",
        telefono: `${codigoPaisContacto} ${nuevoTelefonoContacto}` || "SIN TELÉFONO",
        correo: nuevoCorreoContacto || "SIN CORREO",
      };

      setNuevoContactos([...nuevoContactos, contacto]);
      resetFormularioContacto();
    }
  };

  const handleEliminarContacto = (rowIndex) => {
    setNuevoContactos(nuevoContactos.filter((_, index) => index !== rowIndex));
  };

  const handleDesactivarContacto = async (rowIndex) => {
    const contacto = nuevoContactos[rowIndex];
    if (!contacto || !contacto.id) {
      toast.current.show({
        severity: "warn",
        summary: "ID inválido",
        detail: "No se encontró el ID del contacto a desactivar.",
        life: 3000,
      });
      return;
    }

    try {
      const response = await fetch(
        `${baseUrl}cambiarEstadoContacto?idContacto=${contacto.id}&activo=0`,
        {
          method: "PUT",
          credentials: "include",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        }
      );

      if (response.ok) {
        // Elimina el contacto de la lista para ocultarlo de la tabla
        setNuevoContactos((prev) => prev.filter((_, idx) => idx !== rowIndex));
        toast.current.show({
          severity: "success",
          summary: "Contacto Desactivado",
          detail: "El contacto ha sido desactivado con éxito.",
          life: 3000,
        });
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "No se pudo desactivar el contacto. Debe tener al menos un registro activo.",
          life: 3000,
        });
      }
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error de red",
        detail: "No se pudo desactivar el contacto.",
        life: 3000,
      });
    }
  };

  const handleDesactivarDomicilio = async (rowIndex) => {
    const domicilio = nuevoDirecciones[rowIndex];
    if (!domicilio || !domicilio.id) {
      toast.current.show({
        severity: "warn",
        summary: "ID inválido",
        detail: "No se encontró el ID del domicilio a desactivar.",
        life: 3000,
      });
      return;
    }
    
    try {
      const response = await fetch(
        `${baseUrl}cambiarEstadoDomicilio?idDomicilio=${domicilio.id}&activo=0`,
        {
          method: "PUT",
          credentials: "include",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        }
      );

      if (response.ok) {
        // Elimina el domicilio de la lista para ocultarlo de la tabla
        setNuevoDirecciones((prev) => prev.filter((_, idx) => idx !== rowIndex));
        toast.current.show({
          severity: "success",
          summary: "Domicilio Desactivado",
          detail: "El domicilio ha sido desactivado con éxito.",
          life: 3000,
        });
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "No se pudo desactivar el domicilio. Debe tener al menos un registro activo.",
          life: 3000,
        });
      }
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error de red",
        detail: "No se pudo desactivar el domicilio.",
        life: 3000,
      });
    }
  };

  const handleDesactivarRepresentante = async (rowIndex) => {
    
    const representante = nuevoRepresentantes[rowIndex];
    if (!representante || !representante.id) {
      toast.current.show({
        severity: "warn",
        summary: "ID inválido",
        detail: "No se encontró el ID del representante a desactivar.",
        life: 3000,
      });
      return;
    }
    
    try {
      const response = await fetch(
        `${baseUrl}cambiarEstadoRepresentante?idRepresentante=${representante.id}&activo=0`,
        {
          method: "PUT",
          credentials: "include",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        }
      );

      if (response.ok) {
        // Elimina el representante de la lista para ocultarlo de la tabla
        setNuevoRepresentantes((prev) => prev.filter((_, idx) => idx !== rowIndex));
        toast.current.show({
          severity: "success",
          summary: "Representante Desactivado",
          detail: "El representante ha sido desactivado con éxito.",
          life: 3000,
        });
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "No se pudo desactivar el representante. Debe tener al menos un registro activo.",
          life: 3000,
        });
      }
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error de red",
        detail: "No se pudo desactivar el representante.",
        life: 3000,
      });
    }
  };

  const checkFormContacto = () => {
    const missingFields = [];
    if (!nuevoNombreContacto) missingFields.push("Nombre");
    if (!nuevoTipoContacto) missingFields.push("Tipo");
    if (!nuevoTelefonoContacto) {
      missingFields.push("Teléfono");
    } else if (!validateTelefono(nuevoTelefonoContacto)) {
      missingFields.push("Teléfono (inválido)");
    }
    if (!nuevoCorreoContacto) {
      missingFields.push("Correo");
    } else if (!validateEmail(nuevoCorreoContacto)) {
      missingFields.push("Correo (inválido)");
    }
    return missingFields;
  };

  const handleSeleccionarContacto = (index) => {
    const con = nuevoContactos[index];
    setIdContacto(con.id);
    setNuevoNombreContacto(con.nombre);
    setNuevoTipoContacto(con.tipo);
    setNuevoTelefonoContacto(con.telefono.replace(/^\+\d+\s*/, ''));
    setNuevoCorreoContacto(con.correo);
    setIndiceEdicionContacto(index);
  };

  const handleGuardarCliente = async () => {
    setLoading(true);
    try {
      // Validar campos
      const missingFields = checkFormClientes();
      if (missingFields.length > 0) {
        toast.current.show({
          severity: "error",
          summary: "Error de Validación",
          detail: "Por favor, complete correctamente los siguientes campos: " + missingFields.join(", "),
          life: 3000,
        });
        setLoading(false);
        return;
      }

      // Obtener datos del cliente actual
      const urlCliente = `${baseUrl}getClienteById?idCliente=${idCliente}`;
      const cliente = await fetchData(urlCliente);

      // Preparar datos para actualización
      const rutLimpio = nuevoRut.replace(/[.\s]/g, "");
      const clienteData = new URLSearchParams({
        idCliente: idCliente,
        idEmpresa: nuevaEmpresa,
        idTipoCliente: nuevoTipo,
        rut: rutLimpio,
        razonSocial: nuevaRazon,
        alias: nuevoAlias,
        nombreFantasia: nuevoFanta,
        giro: giro,
        contactos: JSON.stringify(nuevoContactos.map(contacto => ({
          idContacto: contacto.id,
          nombre: contacto.nombre,
          tipo: contacto.tipo,
          telefono: contacto.telefono,
          correo: contacto.correo,
        }))),
        domicilios: JSON.stringify(nuevoDirecciones.map(direccion => ({
          idDomicilio: direccion.id,
          direccion: direccion.direccion,
          tipo: direccion.tipo,
          comuna: direccion.comuna,
          region: direccion.region
        }))),
        representantesLegales: JSON.stringify(nuevoRepresentantes.map(representante => ({
          idRepresentante: representante.id,
          rut: representante.rut,
          nombre: representante.nombre,
          correo: representante.correo,
          telefono: representante.telefono
        }))),
        idCobranza: cliente.id_cobranza
      });

      // Actualizar en bodegas
      const urlBodegas = `${baseUrl}actualizarCliente?${clienteData.toString()}`;
      const responseBodegas = await fetch(urlBodegas, { 
        method: "POST", 
        parseJson: false, 
        credentials: "include", 
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        } 
      });
      if (!responseBodegas.ok) throw new Error("Error al actualizar en bodegas");

      // Actualizar cliente en cobranzas
      const cobranzasUrl = `${urlCobranzas}clientes/editar`;
      const cobranzasData = {
        id: cliente.id_cobranza,
        razonSocial: nuevaRazon,
        rut: rutLimpio
      };
      await fetch(cobranzasUrl, {
        method: "POST",
        body: JSON.stringify(cobranzasData),
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        credentials: "include"
      });

      // Actualizar en documentos
      const documentosParams = new URLSearchParams({
        id: idCliente,
        rut: rutLimpio,
        razonSocial: nuevaRazon,
        giro: giro,
        direccion: nuevoDirecciones[0]?.direccion || "SIN DIRECCION",
        comuna: nuevoDirecciones[0]?.comuna || "SIN COMUNA",
        telefono: nuevoContactos[0]?.telefono || "000000000",
        idCobranza: cliente.id_cobranza
      });
      const documentosUrl = `${urlDocumentos}actualizarCliente?${documentosParams.toString()}`;
      const myHeadersDocumentos = new Headers();
      myHeadersDocumentos.append("Content-Type", "application/json;charset=UTF-8");

      await fetch(documentosUrl, { 
        method: "POST", 
        headers: myHeadersDocumentos, 
        credentials: "include" 
      });

      // Actualizar en medidores
      const medidoresParams = new URLSearchParams({
        rut: rutLimpio,
        razonSocial: nuevaRazon,
        direccion: nuevoDirecciones[0]?.direccion || "SIN DIRECCION",
        comuna: nuevoDirecciones[0]?.comuna || "SIN COMUNA",
        telefono: nuevoContactos[0]?.telefono || "000000000",
        idCobranza: cliente.id_cobranza
      });
      const medidoresUrl = `${urlMedidores}actualizarCliente?${medidoresParams.toString()}`;
      const myHeadersMedidores = new Headers();
      myHeadersMedidores.append("Content-Type", "application/json;charset=UTF-8");

      await fetch(medidoresUrl, { 
        method: "POST", 
        headers: myHeadersMedidores, 
        credentials: "include" 
      });


      toast.current.show({
        severity: "success",
        summary: "Operación Exitosa",
        detail: "El cliente ha sido actualizado correctamente",
        life: 3000,
      });

      if (onSuccess) onSuccess();
    } catch (error) {
      console.error("Error:", error);
      toast.current.show({
        severity: "error",
        summary: "Error en la Operación",
        detail: "No se pudo actualizar el cliente. Por favor, intente nuevamente.",
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCrearCliente = async () => {
    setLoading(true);
    try {
      // Validar campos
      const missingFields = checkFormClientes();
      if (missingFields.length > 0) {
        alert("Faltan completar los siguientes campos: " + missingFields.join(", "));
        setLoading(false);
        return;
      }

      // Preparar datos para creación
      const rutLimpio = nuevoRut.replace(/[.\s]/g, "");
      const bodegasParams = new URLSearchParams({
        idEmpresa: nuevaEmpresa,
        idTipoCliente: nuevoTipo,
        rut: rutLimpio,
        razonSocial: nuevaRazon,
        giro: giro,
        alias: nuevoAlias,
        nombreFantasia: nuevoFanta,
        contactos: JSON.stringify(nuevoContactos.map(contacto => ({
          nombre: contacto.nombre,
          tipo: contacto.tipo,
          telefono: contacto.telefono,
          correo: contacto.correo,
        }))),
        domicilios: JSON.stringify(nuevoDirecciones.map(direccion => ({
          direccion: direccion.direccion,
          tipo: direccion.tipo,
          comuna: direccion.comuna,
          region: direccion.region
        }))),
        representantesLegales: JSON.stringify(nuevoRepresentantes.map(representante => ({
          rut: representante.rut,
          nombre: representante.nombre,
          correo: representante.correo,
          telefono: representante.telefono
        })))
      });

      // Crear en bodegas
      const urlBodegas = `${baseUrl}crearCliente?${bodegasParams.toString()}`;
      let data;
      try {
        const responseBodegas = await fetch(urlBodegas, { method: "POST", headers: { "Content-Type": "application/json;charset=UTF-8" } });
        // Si fetchData no lanza error, significa que la respuesta fue exitosa
        data = typeof responseBodegas.json === 'function' 
          ? await responseBodegas.json() 
          : responseBodegas; // responseBodegas ya es el JSON si parseJson=true
      } catch (error) {
        toast.current.show({
          severity: "error",
          summary: "Rechazado",
          detail: "El RUT del cliente ya existe",
          life: 3000,
        });
        throw new Error("Error al crear el cliente bodegas");
      }

      // // Crear cliente en cobranzas
      const cobranzasUrl = `${urlCobranzas}clientes/agregar`;
      let dataCobranzas;
      const cobranzasData = {
        id: data.idCliente,
        razonSocial: nuevaRazon,
        rut: rutLimpio
      };
      const myHeadersCobranzas = new Headers();
      myHeadersCobranzas.append("Content-Type", "application/json");
      
      const responseCobranzas = await fetch(cobranzasUrl, {
        method: "POST",
        headers: myHeadersCobranzas,
        body: JSON.stringify(cobranzasData),
        credentials: "include" // importante para enviar la cookie SSO al otro subdominio
      });
      dataCobranzas = typeof responseCobranzas.json === 'function' 
          ? await responseCobranzas.json() 
          : responseCobranzas; // responseCobranzas ya es el JSON si parseJson=true
      if (!responseCobranzas.ok) {
        throw new Error("Error al crear cliente en cobranzas");
      }
      
      //actualizar id de cobranza en bodegas
      const updateParams = new URLSearchParams({
        idCliente: data.idCliente,
        idEmpresa: nuevaEmpresa,
        idTipoCliente: nuevoTipo,
        rut: rutLimpio,
        razonSocial: nuevaRazon,
        alias: nuevoAlias,
        nombreFantasia: nuevoFanta,
        giro: giro,
        idCobranza: dataCobranzas.id
      });
      const urlBodegasUpdate = `${baseUrl}actualizarCliente?${updateParams.toString()}`;
      await fetch(urlBodegasUpdate, { method: "POST", headers: { "Content-Type": "application/json;charset=UTF-8" }  });
  

      // Crear en documentos
      const documentosParams = new URLSearchParams({
        id: data.idCliente,
        rut: rutLimpio,
        razonSocial: nuevaRazon,
        giro: giro,
        direccion: nuevoDirecciones[0]?.direccion || "SIN DIRECCION",
        comuna: nuevoDirecciones[0]?.comuna || "SIN COMUNA",
        telefono: nuevoContactos[0]?.telefono || "000000000",
        //idCobranza: dataCobranzas.id
        idCobranza:1111
      });
      const documentosUrl = `${urlDocumentos}insertarCliente?${documentosParams.toString()}`;
      const myHeadersDocumentos = new Headers();
      myHeadersDocumentos.append("Content-Type", "application/json;charset=UTF-8");
        
      const responseDocumentos = await fetch(documentosUrl, { 
        method: "POST",
        headers: myHeadersDocumentos,
        credentials: "include" // importante para enviar la cookie SSO al otro subdominio
      });
      if (!responseDocumentos.ok) {
        throw new Error("Error al crear cliente en documentos")
      };

      // Crear en medidores
      const medidoresParams = new URLSearchParams({
        rut: rutLimpio,
        razonSocial: nuevaRazon,
        direccion: nuevoDirecciones[0]?.direccion || "SIN DIRECCION",
        comuna: nuevoDirecciones[0]?.comuna || "SIN COMUNA",
        telefono: nuevoContactos[0]?.telefono || "000000000",
        idCobranza: dataCobranzas.id
      });
      const medidoresUrl = `${urlMedidores}insertarCliente?${medidoresParams.toString()}`;
      const myHeadersMedidores = new Headers();
      myHeadersMedidores.append("Content-Type", "application/json;charset=UTF-8");
      
      const responseMedidores = await fetch(medidoresUrl, { 
        method: "POST", 
        headers: myHeadersMedidores,
        credentials: "include" // importante para enviar la cookie SSO al otro subdominio
      });
      if (!responseMedidores.ok) {
        throw new Error("Error al crear cliente en medidores");
      }

      toast.current.show({
        severity: "success",
        summary: "Operación Exitosa",
        detail: "El cliente ha sido creado correctamente",
        life: 3000,
      });

      if (onSuccess) onSuccess();
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const confirmGuardar = async () => {
    // Primero verificar si el RUT ya existe (solo en modo creación)
    if (!modoEdicion) {
      try {
      const rutLimpio = nuevoRut.replace(/[.\s]/g, "");
      const url = `${baseUrl}getClienteByRut?rut=${rutLimpio}`;
      const data = await fetchData(url); // usa headers por defecto con autorización

      if (data === true) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "El RUT del cliente ya existe",
          life: 3000,
        });
        return;
      }

      // Si el RUT no existe, continuar con las demás validaciones
      validarCamposFaltantes();
    } catch (error) {
      console.error("Error:", error);
      toast.current.show({
        severity: "error",
        summary: "Error en la Operación",
        detail: "No se pudo validar el RUT. Por favor, intente nuevamente.",
        life: 3000,
      });
    }
  } else {
    // En modo edición, continuar directamente con las validaciones
    validarCamposFaltantes();
  }
  };

  const validarCamposFaltantes = () => {
    const sinRepresentantes = (nuevoRepresentantes.length === 0);
    const sinDirecciones = (nuevoDirecciones.length === 0);
    const sinContactos = (nuevoContactos.length === 0);

    if (sinRepresentantes && sinDirecciones && sinContactos) {
      const continuar = window.confirm(
        "Atención: No se han registrado datos de contacto para este cliente.\n\n" +
        "• No hay representantes legales registrados\n" +
        "• No hay direcciones registradas\n" +
        "• No hay contactos registrados\n\n" +
        "Si ha ingresado información en estos campos, por favor presione 'Agregar' para guardarlos.\n" +
        "De lo contrario, estos campos quedarán vacíos en el registro.\n\n" +
        "¿Desea continuar con el registro?"
      );
      if (!continuar) return;
    }
    
    if (modoEdicion) {
      handleGuardarCliente();
    } else {
      handleCrearCliente();
    }
  };

  const checkFormClientes = () => {
    const missingFields = [];
    if (!nuevaEmpresa) missingFields.push("Empresa");
    if (!nuevoRut) {
      missingFields.push("Rut");
    } else if (!isValid) {
      missingFields.push("Rut (inválido)");
    }
    if (!nuevaRazon) missingFields.push("Razón Social / Nombre");
    if (!giro) missingFields.push("Giro");
    if (!nuevoTipo) missingFields.push("Tipo de Cliente");
    if (!nuevoAlias) missingFields.push("Alias");
    if (!nuevoFanta) missingFields.push("Nombre Fantasía");
    return missingFields;
  };

  return (
    <>

      <Toast ref={toast} />
      {/* Barra de progreso (Steps) */}
      <div className="overflow-x-auto">
        <Steps 
          model={stepsItems} 
          activeIndex={activeStep} 
          onSelect={handleStepChange}
          className="min-w-max whitespace-nowrap cursor-pointer"
          style={{ cursor: 'pointer' }}
          readOnly={false}
        />
      </div>
      {/* Step 1: Datos del Cliente */}
      {activeStep === 0 && (
        <div className="card">
          {/* Titulo */}
          <h6>{modoEdicion ? "Modifique los datos del cliente" : "Ingrese los datos del cliente a registrar"}</h6>
          
          {/* Formulario */}
          <div className="p-fluid formgrid grid">
            {/* Empresa */}
            <div className="field col-12 md:col-3 mt-2">
              <label className={mostrarError('empresa') ? "text-red-500" : ""}>Empresa *</label>
              <Dropdown
                id="Empresa"
                value={nuevaEmpresa}
                onChange={(e) => {
                  //console.log("Empresa seleccionada:", e.value);
                  setNuevaEmpresa(e.value);
                  handleCampoTocado('empresa');
                }}
                onBlur={() => handleCampoTocado('empresa')}
                options={empresas}
                optionLabel="nombre"
                optionValue="id"
                placeholder="Seleccione Empresa"
                className={`p-inputtext-sm ${mostrarError('empresa') ? 'p-invalid' : ''}`}
                style={{ 
                  borderRadius: "4px",
                  borderColor: mostrarError('empresa') ? "#dc3545" : "#ced4da"
                }}
                filter
              />
              {mostrarError('empresa') && (
                <small className="p-error">Este campo es obligatorio</small>
              )}
            </div>
            {/* Rut */}
            <div className="field col-12 md:col-3 mt-2">
              <label className={mostrarError('rut') ? "text-red-500" : ""}>Rut *</label>
              <InputText
                id="rut"
                type="text"
                value={nuevoRut || ""}
                onChange={(e) => {
                  handleRutChange(e);
                  handleCampoTocado('rut');
                }}
                onBlur={() => {
                  handleRutBlur();
                  handleCampoTocado('rut');
                }}
                maxLength={12}
                className={`p-inputtext-sm ${mostrarError('rut') ? 'p-invalid' : ''}`}
                style={{
                  borderColor: mostrarError('rut') ? "#dc3545" : "#ced4da",
                  borderRadius: "4px",
                }}
                placeholder="Ingrese RUT"
                readOnly={modoEdicion}
              />
              {mostrarError('rut') && (
                <small className="p-error">
                  {rutExiste ? "Este RUT ya existe" : "Este campo es obligatorio y debe ser válido"}
                </small>
              )}
            </div>
            {/* Razón Social / Nombre */}
            <div className="field col-12 md:col-3 mt-2">
              <label className={mostrarError('razonSocial') ? "text-red-500" : ""}>Razón Social / Nombre *</label>
              <InputText
                id="razonSocial"
                type="text"
                value={nuevaRazon || ""}
                onChange={(e) => {
                  setNuevaRazon(e.target.value.toUpperCase());
                  handleCampoTocado('razonSocial');
                }}
                onBlur={() => handleCampoTocado('razonSocial')}
                maxLength={90}
                className={`p-inputtext-sm ${mostrarError('razonSocial') ? 'p-invalid' : ''}`}
                style={{ 
                  borderRadius: "4px",
                  borderColor: mostrarError('razonSocial') ? "#dc3545" : "#ced4da"
                }}
                placeholder="Ingrese razón social"
              />
              {mostrarError('razonSocial') && (
                <small className="p-error">Este campo es obligatorio</small>
              )}
            </div>
            {/* Giro */}
            <div className="field col-12 md:col-3 mt-2">
              <label className={mostrarError('giro') ? "text-red-500" : ""}>Giro *</label>
              <InputText
                id="giro"
                type="text"
                value={giro || ""}
                onChange={(e) => {
                  setGiro(e.target.value.toUpperCase());
                  handleCampoTocado('giro');
                }}
                onBlur={() => handleCampoTocado('giro')}
                maxLength={45}
                className={`p-inputtext-sm ${mostrarError('giro') ? 'p-invalid' : ''}`}
                style={{ 
                  borderRadius: "4px",
                  borderColor: mostrarError('giro') ? "#dc3545" : "#ced4da"
                }}
                placeholder="Ingrese giro"
              />
              {mostrarError('giro') && (
                <small className="p-error">Este campo es obligatorio</small>
              )}
            </div>
            {/* Alias */}
            <div className="field col-12 md:col-3 mt-2">
              <label className={mostrarError('alias') ? "text-red-500" : ""}>Alias *</label>
              <InputText
                id="alias"
                type="text"
                value={nuevoAlias || ""}
                onChange={(e) => {
                  setNuevoAlias(e.target.value.toUpperCase());
                  handleCampoTocado('alias');
                }}
                onBlur={() => handleCampoTocado('alias')}
                maxLength={90}
                className={`p-inputtext-sm ${mostrarError('alias') ? 'p-invalid' : ''}`}
                style={{ 
                  borderRadius: "4px",
                  borderColor: mostrarError('alias') ? "#dc3545" : "#ced4da"
                }}
                placeholder="Ingrese alias"
              />
              {mostrarError('alias') && (
                <small className="p-error">Este campo es obligatorio</small>
              )}
            </div>
            {/* Tipo de Cliente */}
            <div className="field col-12 md:col-3 mt-2">
              <label className={mostrarError('tipoCliente') ? "text-red-500" : ""}>Tipo de Cliente *</label>
              <Dropdown
                id="tipocliente"
                value={nuevoTipo}
                onChange={(e) => {
                  //console.log("Tipo seleccionado:", e.value);
                  setNuevoTipo(e.value);
                  handleCampoTocado('tipoCliente');
                }}
                onBlur={() => handleCampoTocado('tipoCliente')}
                options={tipos}
                optionLabel="nombre"
                optionValue="id"
                placeholder="Seleccione una opción"
                className={`p-inputtext-sm ${mostrarError('tipoCliente') ? 'p-invalid' : ''}`}
                style={{ 
                  borderRadius: "4px",
                  borderColor: mostrarError('tipoCliente') ? "#dc3545" : "#ced4da"
                }}
                filter
              />
              {mostrarError('tipoCliente') && (
                <small className="p-error">Este campo es obligatorio</small>
              )}
            </div>
            {/* Nombre Fantasía */}
            <div className="field col-12 md:col-6 mt-2">
              <label className={mostrarError('nombreFantasia') ? "text-red-500" : ""}>Nombre Fantasía *</label>
              <InputText
                id="nombreFantasia"
                type="text"
                value={nuevoFanta || ""}
                onChange={(e) => {
                  setNuevoFanta(e.target.value.toUpperCase());
                  handleCampoTocado('nombreFantasia');
                }}
                onBlur={() => handleCampoTocado('nombreFantasia')}
                maxLength={90}
                className={`p-inputtext-sm ${mostrarError('nombreFantasia') ? 'p-invalid' : ''}`}
                style={{ 
                  borderRadius: "4px",
                  borderColor: mostrarError('nombreFantasia') ? "#dc3545" : "#ced4da"
                }}
                placeholder="Ingrese nombre de fantasía"
              />
              {mostrarError('nombreFantasia') && (
                <small className="p-error">Este campo es obligatorio</small>
              )}
            </div>
          </div>
          {/* Navegación entre steps */}
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button 
              label="" 
              rounded 
              outlined 
              icon="pi pi-arrow-right" 
              iconPos="right" 
              className="" 
              onClick={() => setActiveStep(1)}
            />
          </div>
        </div>
      )}
      {/* Step 2: Representantes Legales */}
      {activeStep === 1 && (
        <div className="card">
          {/* Título */}
          <div className="p-d-flex p-jc-between p-ai-center mb-3">
            <div>
              <h6>Ingrese los datos del representante a registrar</h6>
            </div>
          </div>
          {/* Formulario */}
          <div className="p-fluid formgrid grid">
            {/* rut repre */}
            <div className="field col-12 md:col-2">
              <label className={erroresRepresentante.rut ? "text-red-500" : ""}>Rut *</label>
              <InputText
                id="rutRepresentante"
                type="text"
                value={nuevoRutRepresentante || ""}
                onChange={handleRutRepresentanteChange} 
                onBlur={handleRutRepresentanteBlur} 
                className={`p-inputtext-sm ${erroresRepresentante.rut ? 'p-invalid' : ''}`}
                style={{ 
                  borderRadius: "4px",
                  borderColor: erroresRepresentante.rut ? "#dc3545" : "#ced4da"
                }}
                placeholder="Ingrese RUT"
                maxLength={12}
              />
              {erroresRepresentante.rut && (
                <small className="p-error">RUT inválido</small>
              )}
            </div>

            {/* Nom repre */}
            <div className="field col-12 md:col-2">
              <label className={erroresRepresentante.nombre ? "text-red-500" : ""}>Nombre *</label>
              <InputText
                id="nombreRepresentante"
                type="text"
                value={nuevoNombreRepresentante || ""}
                onChange={(e) => setNuevoNombreRepresentante(e.target.value.toUpperCase())}
                className={`p-inputtext-sm ${erroresRepresentante.nombre ? 'p-invalid' : ''}`}
                style={{ 
                  borderRadius: "4px",
                  borderColor: erroresRepresentante.nombre ? "#dc3545" : "#ced4da"
                }}
                placeholder="Ingrese nombre"
                maxLength={45}
              />
              {erroresRepresentante.nombre && (
                <small className="p-error">Este campo es obligatorio</small>
              )}
            </div>

            {/* telefono repre */}
            <div className="field col-12 md:col-3">
              <label className={erroresRepresentante.telefono ? "text-red-500" : ""}>Teléfono *</label>
              <div className="p-inputgroup">
                <Dropdown
                  value={codigoPais}
                  options={codigosPaises}
                  onChange={(e) => setCodigoPais(e.value)}
                  style={{ width: '50%' }}
                />
                <InputText
                  id="telefonoRepresentante"
                  type="text"
                  value={nuevoTelefonoRepresentante || ""}
                  onChange={handleTelefonoRepresentanteChange}
                  className={`p-inputtext-sm ${erroresRepresentante.telefono ? 'p-invalid' : ''}`}
                  style={{ 
                    borderRadius: "4px",
                    borderColor: erroresRepresentante.telefono ? "#dc3545" : "#ced4da",
                    width: '100%'
                  }}
                  placeholder="9 999 9999"
                  maxLength={9}
                />
              </div>
              {erroresRepresentante.telefono && (
                <small className="p-error">Teléfono inválido</small>
              )}
            </div>
            {/* correo */}
            <div className="field col-12 md:col-3">
              <label className={erroresRepresentante.correo ? "text-red-500" : ""}>Correo *</label>
              <InputText
                id="correoRepresentante"
                type="email"
                value={nuevoCorreoRepresentante || ""}
                onChange={handleCorreoRepresentanteChange}
                className={`p-inputtext-sm ${erroresRepresentante.correo ? 'p-invalid' : ''}`}
                style={{ 
                  borderRadius: "4px",
                  borderColor: erroresRepresentante.correo ? "#dc3545" : "#ced4da"
                }}
                placeholder="Ingrese correo"
                maxLength={45}
              />
              {erroresRepresentante.correo && (
                <small className="p-error">Correo inválido</small>
              )}
            </div>

            {/* Botón para agregar representante */}
            <div className="field col-12 md:col-2 mt-4">
              <Button
                label={indiceEdicionRepresentante !== null ? "Guardar" : "Agregar"}
                icon={indiceEdicionRepresentante !== null ? "pi pi-save" : "pi pi-plus"}
                className="p-button-rounded p-button-outlined p-button-success"
                onClick={handleGuardarRepresentante}
              />
            </div>
            {/* Tabla de representantes agregados */}
            <Card className="mt-2" style={{ width: '100%' }}>
              {nuevoRepresentantes.length > 0 ? (
                <>
                  {/*console.log("Representantes en estado:", nuevoRepresentantes)*/}
                  <DataTable
                    value={nuevoRepresentantes}
                    dataKey="id"
                    scrollHeight="150px"
                    className="p-datatable-sm"
                    tableStyle={{ fontSize: '0.875rem' }}
                  >
                    <Column field="rut" header="RUT" />
                    <Column field="nombre" header="Nombre" />
                    <Column field="telefono" header="Teléfono" />
                    <Column field="correo" header="Correo" />
                    <Column
                      header="Acciones"
                      body={(rowData, options) => (
                        <div className="p-d-flex p-ai-center">
                          <Button
                            icon="pi pi-pencil"
                            size="small"
                            text
                            onClick={() => handleSeleccionarRepresentante(options.rowIndex)}
                          />
                          {modoEdicion ? (
                            <Button
                              icon="pi pi-times"
                              size="small"
                              severity="danger"
                              text
                              onClick={() => handleDesactivarRepresentante(options.rowIndex)}
                            />
                          ): (
                            <Button
                              icon="pi pi-times"
                              size="small"
                              severity="danger"
                              text
                              onClick={() => handleEliminarRepresentante(options.rowIndex)}
                            />
                          )}
                        </div>
                      )}
                    />
                  </DataTable>
                </>
              ) : (
                <p className="p-text-center">No se han agregado representantes.</p>
              )}
            </Card>
          </div>
          <br></br>
          {/* Navegación entre steps */}
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Button label="" icon="pi pi-arrow-left" rounded outlined onClick={() => setActiveStep(0)} />
            <Button label="" icon="pi pi-arrow-right" rounded outlined iconPos="right" onClick={() => setActiveStep(2)} />
          </div>
        </div>
      )}
      {/* Step 3: Direcciones */}
      {activeStep === 2 && (
        <div className="card">
          {/* Título */}
          <div className="p-d-flex p-jc-between p-ai-center mb-3">
            <div>
              <h6 > Ingrese las direcciones a registrar </h6>
            </div>
          </div>
          {/* Formulario */}
          <div className="p-fluid formgrid grid">
            {/* tipo direccion */}
            <div className="field col-12 md:col-2">
              <label >Tipo</label>
              <Dropdown
                id="tipodireccion"
                value={nuevoTipoDireccion}
                onChange={(e) => setNuevoTipoDireccion(e.value)}
                options={[
                  { name: 'COMERCIAL', value: 'COMERCIAL' },
                  { name: 'NATURAL', value: 'NATURAL' },
                  { name: 'OTRO', value: 'OTRO' }
                ]}
                optionLabel="name"
                placeholder="Seleccione una opción"
                className="p-inputtext-sm"
                style={{ borderRadius: "4px" }}
              />
            </div>
            {/* dirección*/}
            <div className="field col-12 md:col-2">
              <label > Dirección </label>
              <InputText
                id="direccion"
                type="text"
                value={nuevaDireccion}
                onChange={(e) =>
                  setNuevaDireccion(e.target.value.toUpperCase())
                }
                className="p-inputtext-sm"
                style={{ borderRadius: "4px" }}
                placeholder="Ingrese dirección"
                maxLength={45}
              />
            </div>
            {/* region */}
            <div className="field col-12 md:col-3">
              <label>Región</label>
              <Dropdown
                id="region"
                value={region}
                onChange={(e) => {
                  setRegion(e.value);
                  setComuna(""); // Resetear comuna cuando cambia la región
                }}
                options={regiones}
                placeholder="Seleccione una región"
                className="p-inputtext-sm"
                style={{ borderRadius: "4px" }}
              />
            </div>
            {/* comuna */}
            <div className="field col-12 md:col-3">
              <label>Comuna</label>
              <Dropdown
                id="comuna"
                value={comuna}
                onChange={(e) => setComuna(e.value)}
                options={comunas}
                placeholder="Seleccione una comuna"
                className="p-inputtext-sm"
                style={{ borderRadius: "4px" }}
                disabled={!region} // Deshabilitar si no hay región seleccionada
              />
            </div>
            {/* Botón para agregar direccion */}
            <div className="field col-12 md:col-2 mt-4">
              <Button
                label={indiceEdicionDireccion !== null ? "Guardar" : "Agregar"}
                icon={indiceEdicionDireccion !== null ? "pi pi-save" : "pi pi-plus"}
                className="p-button-rounded p-button-outlined p-button-success"
                onClick={handleGuardarDireccion}
              />
            </div>
            {/* Tabla de direcciones agregadas */}
            <Card className="mt-2" style={{ width: '100%' }}>
              {nuevoDirecciones.length > 0 ? (
                <DataTable
                  value={nuevoDirecciones}
                  scrollHeight="150px" 
                  className="p-datatable-sm"
                  tableStyle={{ fontSize: '0.875rem' }} // Estilo compacto
                >
                  <Column field="tipo" header="Tipo" />
                  <Column field="direccion" header="Dirección" />
                  <Column field="region" header="Región" />
                  <Column field="comuna" header="Comuna" />
                  <Column
                    header="Acciones"
                    body={(rowData, options) => (
                      <div className="p-d-flex p-ai-center">
                        <Button
                          icon="pi pi-pencil"
                          size="small"
                          text
                          onClick={() => handleSeleccionarDireccion(options.rowIndex)}
                        />
                        {modoEdicion ? (
                          <Button
                            icon="pi pi-times"
                            size="small"
                            severity="danger"
                            text
                            onClick={() => handleDesactivarDomicilio(options.rowIndex)}
                          />
                        ):(
                          <Button
                            icon="pi pi-times"
                            size="small"
                            severity="danger"
                            text
                            onClick={() => handleEliminarDireccion(options.rowIndex)}
                          />
                        )} 

                      </div>
                    )}
                  />
                </DataTable>
              ) : (
                <p className="p-text-center">No se han agregado direcciones.</p>
              )}
            </Card>
          </div>
          <br></br>
          {/* Navegación entre steps */}
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Button label="" icon="pi pi-arrow-left" rounded outlined onClick={() => setActiveStep(1)} />
            <Button label="" icon="pi pi-arrow-right" rounded outlined iconPos="right" onClick={() => setActiveStep(3)} />
          </div>
        </div>
      )}
      {/* Step 4: Contacto */}
      {activeStep === 3 && (
        <div className="card">
          {/* Título */}
          <div className="p-d-flex p-jc-between p-ai-center mb-3">
            <div>
              <h6 > Ingrese los contactos a registrar </h6>
            </div>
          </div>
          {/* Formulario */}
          <div className="p-fluid formgrid grid">
            {/* tipo */}
            <div className="field col-12 md:col-2">
              <label >Tipo</label>
              <Dropdown
                id="tipoContacto"
                value={nuevoTipoContacto}
                onChange={(e) => setNuevoTipoContacto(e.value)}
                options={[
                  { name: 'COMERCIAL', value: 'COMERCIAL' },
                  { name: 'NATURAL', value: 'NATURAL' },
                  { name: 'OTRO', value: 'OTRO' }
                ]}
                optionLabel="name"
                placeholder="Seleccione una opción"
                className="p-inputtext-sm"
                style={{ borderRadius: "4px" }}
              />
            </div>
            {/* nombre */}
            <div className="field col-12 md:col-2">
              <label >Nombre</label>
              <InputText
                id="NombreContacto"
                type="text"
                value={nuevoNombreContacto || ""}
                onChange={(e) =>
                  setNuevoNombreContacto(e.target.value.toUpperCase())
                }
                className="p-inputtext-sm"
                style={{ borderRadius: "4px" }}
                placeholder="Ingrese Nombre"
                maxLength={45}
              />
            </div>
            {/* telefono*/}
            <div className="field col-12 md:col-3">
              <label>Telefono</label>
              <div className="p-inputgroup">
                <Dropdown
                  value={codigoPaisContacto}
                  options={codigosPaises}
                  onChange={(e) => setCodigoPaisContacto(e.value)} 
                  style={{ width: '50%' }}
                />
                <InputText
                  id="telefonoContacto"
                  type="text"
                  value={nuevoTelefonoContacto || ""}
                  onChange={handleTelefonoContactoChange}
                  className="p-inputtext-sm"
                  placeholder="9 999 999"
                  maxLength={9}
                  style={{ width: '80%' }}
                />
              </div>
            </div>
            {/* correo */}
            <div className="field col-12 md:col-3">
              <label>Correo</label>
              <InputText
                id="correoContacto"
                type="text"
                value={nuevoCorreoContacto || ""}
                onChange={handleCorreoContactoChange}
                className="p-inputtext-sm"
                style={{ borderRadius: "4px" }}
                placeholder="Ingrese correo"
                maxLength={45}
              />
            </div>
            {/* Botón para agregar direccion */}
            <div className="field col-12 md:col-2 mt-4">
              <Button
                label={indiceEdicionContacto !== null ? "Guardar" : "Agregar"}
                icon={indiceEdicionContacto !== null ? "pi pi-save" : "pi pi-plus"}
                className="p-button-rounded p-button-outlined p-button-success"
                onClick={handleGuardarContacto}
              />
            </div>
            {/* Tabla de contactos agregadas */}
            <Card className="mt-2" style={{ width: '100%' }}>
              {nuevoContactos.length > 0 ? (
                  <DataTable
                    value={nuevoContactos}
                    scrollHeight="150px" 
                    className="p-datatable-sm"
                    tableStyle={{ fontSize: '0.875rem'}} // Estilo compacto
                  >
                    <Column field="tipo" header="Tipo" />
                    <Column field="nombre" header="Nombre" />
                    <Column field="telefono" header="Teléfono" />
                    <Column field="correo" header="Correo" />
                    <Column
                      header="Acciones"
                      body={(rowData, options) => (
                        <div className="p-d-flex p-ai-center">
                          <Button
                            icon="pi pi-pencil"
                            size="small"
                            text
                            onClick={() => handleSeleccionarContacto(options.rowIndex)}
                          />
                          {modoEdicion ? (
                            <Button
                              icon="pi pi-times"
                              size="small"
                              severity="danger"
                              text
                              onClick={() => handleDesactivarContacto(options.rowIndex)}
                            />
                          ) : (
                            <Button
                              icon="pi pi-times"
                              size="small"
                              severity="danger"
                              text
                              onClick={() => handleEliminarContacto(options.rowIndex)}
                            />
                          )}
                        </div>
                      )}
                    />
                  </DataTable>
              ) : (
                <p className="p-text-center">No se han agregado contactos.</p>
              )}
            </Card>
          </div>
          <br></br>
          {/* Navegación entre steps */}
          <div className="flex-space-between">
            <Button label="" icon="pi pi-arrow-left" rounded outlined onClick={() => setActiveStep(2)} />
          </div>
        </div>
      )}
      <div className="flex justify-content-end mt-4">
        <Button
          type="button"
          label="Cancelar"
          icon="pi pi-times"
          onClick={onClose}
          className="p-button-outlined mr-2 p-button-md"
          rounded
          raised
        />
        <Button
          type="button"
          label={loading ? "Guardando..." : "Guardar"}
          icon={loading ? "pi pi-spin pi-spinner" : "pi pi-save"}
          onClick={confirmGuardar}
          className="p-button p-button-md"
          severity="success"
          rounded
          autoFocus
          loading={loading}
          disabled={loading}
          raised
        />
      </div>
    </>
  );
};

export default FormCrearCliente;
